module.exports = __webpack_public_path__ + "img/default-cobranded-hero.753a4ca.webp";